import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import API_BASE from "../config/api";

export default function WebPortfolio() {

    // Get full name from localStorage
    const userData = JSON.parse(localStorage.getItem("user"));
    const fullName = userData?.fullname || "User";
    const personaluid = userData?.personaluid || "";

    const [domain, setDomain] = useState("");
    const [portfolioData, setPortfolioData] = useState([]);
    const [formData, setFormData] = useState({
        type: "photos",
        title: "",
        profilepics: null,
        youtubelink: ""
    });

    const showToast = (message, icon) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: icon,
            title: message,
            showConfirmButton: false,
            timer: 1500
        });
    };

    // LOAD EXISTING PORTFOLIO DATA
    const fetchPortfolio = () => {
        fetch(`${API_BASE}/api/get_webportfolio.php?personaluid=${personaluid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setDomain(data.domain || "");
                    setPortfolioData(data.data || []);
                }
            });
    };

    useEffect(() => {
        fetchPortfolio();
    }, []);

    // HANDLE FORM CHANGE
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData({
            ...formData,
            [name]: files ? files[0] : value
        });
    };

    // DELETE UPLOADED CONTENT
    const handleDelete = (id) => {
        Swal.fire({
            title: "Delete this content?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            confirmButtonText: "Yes, delete it",
        }).then((r) => {
            if (!r.isConfirmed) return;
            fetch(`${API_BASE}/api/delete_webportfolio.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id, personaluid, domain }),
            })
                .then((res) => res.json())
                .then((data) => {
                    showToast(data.message, data.success ? "success" : "error");
                    if (data.success) fetchPortfolio();
                })
                .catch(() => showToast("Network error", "error"));
        });
    };

    // HANDLE FORM SUBMIT
    const handleSubmit = (e) => {

        e.preventDefault();

        if (!formData.title) {
            showToast("Title is required", "error");
            return;
        }

        if (!formData.profilepics && formData.type === "photos") {
            showToast("Please upload an image", "error");
            return;
        }

        const fd = new FormData();
        fd.append("personaluid", personaluid);
        fd.append("domain", domain);
        fd.append("type", formData.type);
        fd.append("title", formData.title);
        fd.append("link", formData.youtubelink || "");
        if (formData.profilepics) fd.append("profilepics", formData.profilepics);

        fetch(`${API_BASE}/api/save_webportfolio.php`, {
            method: "POST",
            body: fd
        })
            .then(res => res.json())
            .then(data => {
                showToast(data.message, data.success ? "success" : "error");
                if (data.success) {
                    setFormData({
                        type: "photos",
                        title: "",
                        profilepics: null,
                        youtubelink: ""
                    });
                    fetchPortfolio(); // Refresh table
                }
            });
    };

    return (
        <div className="container-fluid px-4 py-3">

            {/* Page Header */}
            <div
                className="rounded p-3 mb-3 shadow-sm"
                style={{ background: "linear-gradient(135deg, #e8f0ff, #fefefe)", borderLeft: "6px solid #4a90e2" }}
            >
                <h5 className="fw-bold text-dark mb-1">Website - Portfolio</h5>
                <p className="text-secondary mb-0">
                    Update your website contents! of <b>{fullName}</b>
                </p>
            </div>

            {/* Upload Form */}
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body">

                    <form autoComplete="off" onSubmit={handleSubmit} encType="multipart/form-data">

                        <input type="hidden" name="domain" value={domain} />

                        <div className="row">
                            {/* Type */}
                            <div className="col-md-2 mb-3">
                                <label className="form-label fw-semibold">
                                    Type <span className="text-danger">*</span>
                                </label>
                                <select name="type" className="form-select form-select-sm"
                                    value={formData.type} onChange={handleChange}>
                                    <option value="photos">Photo</option>
                                    <option value="ytvideos">Video</option>
                                </select>
                            </div>

                            {/* Title */}
                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">
                                    Title <span className="text-danger">*</span>
                                </label>
                                <input type="text" name="title" className="form-control form-control-sm"
                                    placeholder="Title about it"
                                    value={formData.title}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {/* Photo Upload */}
                            {formData.type === "photos" &&
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-semibold">
                                        Photo <span className="text-danger">*</span>
                                    </label>
                                    <input type="file" name="profilepics" accept="image/*"
                                        className="form-control form-control-sm"
                                        onChange={handleChange} />
                                </div>
                            }

                            {/* Youtube Link */}
                            {formData.type === "ytvideos" &&
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-semibold">
                                        Youtube Link <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" name="youtubelink" className="form-control form-control-sm"
                                        placeholder="Youtube video link"
                                        value={formData.youtubelink}
                                        onChange={handleChange} />
                                </div>
                            }

                        </div>

                        {/* Submit Button */}
                        <div className="text-end">
                            <button type="submit" className="btn btn-primary px-4 mt-2">
                                <i className="bi bi-cloud-upload-fill me-1"></i>
                                Add Content
                            </button>
                        </div>

                    </form>

                </div>
            </div>

            {/* Uploaded Content Table */}
            <div className="card shadow-sm border-0">
                <div className="card-body">

                    <h5 className="fw-bold mb-3">Uploaded Content</h5>

                    <div className="table-responsive">
                        <table className="table table-sm table-hover table-striped align-middle text-center">
                            <thead className="table-light">
                                <tr>
                                    <th>S.No.</th>
                                    <th>Type</th>
                                    <th>Title</th>
                                    <th>Link</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {portfolioData.length > 0 ? portfolioData.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.type}</td>
                                        <td>{item.title}</td>
                                        <td>
                                            {item.type === "photos" ? (
                                                <img
                                                    src={item.link}
                                                    alt={item.title}
                                                    style={{ maxWidth: "100px" }}
                                                    onError={(e) => (e.target.src = "/assets/default.png")}
                                                />

                                            ) : (
                                                <a href={item.link} target="_blank" rel="noopener noreferrer">{item.link}</a>
                                            )}
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => handleDelete(item.id)}
                                                title="Delete"
                                            >
                                                <i className="bi bi-trash"></i> Delete
                                            </button>
                                        </td>

                                    </tr>
                                )) : (
                                    <tr><td colSpan="5">No data found</td></tr>
                                )}
                            </tbody>

                        </table>
                    </div>

                </div>
            </div>

        </div>
    );
}
